const defaultLocale = 'es-CL';

export const formatNumber = (value: number, options: Intl.NumberFormatOptions = {}) => {
  if (Number.isNaN(value) || value === null || value === undefined) {
    return '-';
  }
  return new Intl.NumberFormat(defaultLocale, {
    maximumFractionDigits: 2,
    ...options,
  }).format(value);
};

export const formatCurrency = (value: number, currency: string = 'CLP') => {
  if (Number.isNaN(value) || value === null || value === undefined) {
    return '-';
  }
  return new Intl.NumberFormat(defaultLocale, {
    style: 'currency',
    currency,
    maximumFractionDigits: currency === 'CLP' ? 0 : 2,
  }).format(value);
};

export const formatPercentage = (value: number, options: { maximumFractionDigits?: number } = {}) => {
  if (Number.isNaN(value) || value === null || value === undefined) {
    return '-';
  }
  const formatter = new Intl.NumberFormat(defaultLocale, {
    style: 'percent',
    maximumFractionDigits: options.maximumFractionDigits ?? 1,
  });
  return formatter.format(value);
};

export const formatDateTime = (value: string | Date, options: Intl.DateTimeFormatOptions = {}) => {
  if (!value) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat(defaultLocale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    ...options,
  }).format(date);
};

export const formatMarkdownTable = (
  rows: Array<Record<string, any>>,
  opts: { headers?: string[]; headerMap?: Record<string, string> } = {}
) => {
  if (!rows || rows.length === 0) {
    return '';
  }

  const columns = opts.headers ?? Object.keys(rows[0] ?? {});
  if (columns.length === 0) {
    return '';
  }

  const headerRow = columns
    .map((key) => escapeMarkdown(opts.headerMap?.[key] ?? toTitleCase(key)))
    .join(' | ');
  const separatorRow = columns.map(() => '---').join(' | ');

  const body = rows
    .map((row) =>
      columns
        .map((key) => formatTableValue(row[key]))
        .join(' | ')
    )
    .join('\n');

  return `${headerRow}\n${separatorRow}\n${body}`;
};

const formatTableValue = (value: any): string => {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'number') return formatNumber(value);
  if (typeof value === 'boolean') return value ? 'Sí' : 'No';
  if (value instanceof Date) return formatDateTime(value);
  if (Array.isArray(value)) return value.map((item) => formatTableValue(item)).join(', ');
  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([key, val]) => `${toTitleCase(key)}: ${formatTableValue(val)}`)
      .join(', ');
  }
  return escapeMarkdown(String(value));
};

const escapeMarkdown = (text: string) =>
  text.replace(/\|/g, '\\|').replace(/\n/g, '<br />');

const toTitleCase = (value: string) =>
  value
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^[a-z]/, (match) => match.toUpperCase());












